import { EditPendidikanPayload } from "../../../../models/Pendidikan";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { allPendidikanKey } from "../../queries/Pendidikan/useFetchAllPendidikan";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function editPendidikan(data: EditPendidikanPayload) {
  const res = await ApiClient.put(`/EditPendidikanSelection`, data);
  return res.data;
}

export const useEditPendidikan = mutationWrapper(editPendidikan, {
  onSuccess: () => {
    getQueryClient().invalidateQueries(allPendidikanKey);
  },
});
